import { computed } from "vue";
import { QualIssue } from '@/services/QualClasses';
import { useFormStores as useStores } from '@/rules/_useFormStores';

export const rules = {
  // check if enabled and complete
  PermissionToRequestNip: computed(() => {
    let { form } = useStores('financing');
    if (form.nip.PermissionToRequestNip === false) {
      return new QualIssue({
        view: 'formFinancingNip',
        type: 'warning',
        title: 'U wil geen hulp bij de subsidieaanvraag',
        description:
          'U draagt zelf verantwoordelijkheid voor het indienen van de aanvraag.',
      });
    }
    return null;
  }),
  
};
